<!--
Author: jiangli
Date: 2024-04-22
Desc: 快速交易
 -->
<template>
    <div>
        <!-- <comp-title-dc back-url-name="home">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/quickTrade' }">基金交易</el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc> -->
        <div v-if="$util.belongHx()" class="bor_F1F1F1 box">
            <quickBuy :is-public="isPublic"></quickBuy>
        </div>
        <el-tabs v-else v-model="activeName" class="bor_F1F1F1 pl25">
            <el-tab-pane label="购买基金" name="1">
                <quickBuy ref="pane1"></quickBuy>
            </el-tab-pane>
            <el-tab-pane label="赎回" name="2">
                <quickSell ref="pane2"></quickSell>
            </el-tab-pane>
            <el-tab-pane label="转换" name="3">
                <quick-change ref="pane3" change-type="change"></quick-change>
            </el-tab-pane>
            <el-tab-pane label="赎回转申购" name="4">
                <quick-change ref="pane4" change-type="buy"></quick-change>
            </el-tab-pane>
            <!-- <el-tab-pane label="跨系统转托管" name="5">跨系统转托管</el-tab-pane> -->
        </el-tabs>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import quickBuy from "../../components/fund/quickBuy.vue";
// import quickSell from "./quickSell.vue";
// import quickChange from "../../components/fund/quickChange.vue";
export default {
    name: "QuickTrade",
    components: {
        quickBuy
        // quickSell,
        // quickChange
    },
    mixins: [mixin],
    data() {
        return {
            activeName: "1", // 所选tab
            isPublic: true // 是否公募基金
        };
    },
    watch: {
        activeName(val) {
            if (this.$refs["pane" + val] && this.$refs["pane" + val]["getList" + val]) {
                this.$refs["pane" + val].pageoffset = 1;
                this.$refs["pane" + val]["getList" + val]();
            } else if (this.$refs["pane" + val] && this.$refs["pane" + val]["getList"]) {
                this.$refs["pane" + val].pageoffset = 1;
                this.$refs["pane" + val]["getList"]();
            }
        }
    },
    created() {
        this.isPublic = this.$route.name == "fund";
        if (this.$route.query && this.$route.query.tab) {
            this.activeName = this.$route.query.tab;
        }
    },
    mounted() {
        if (!this.$util.belongHx()) {
            setTimeout(() => {
                this.assignTipAndQuestion();
            }, 1000);
        }
    },
    methods: {
        // 赋值温馨提示和常见问题
        assignTipAndQuestion() {
            if (this.activeName == "1") {
                this.commonQuestion = [
                    {
                        title: "1.什么是基金认购？认购后基金封闭期多长？",
                        answer: "基金认购是指在开放式基金募集期间、基金尚未成立时购买基金份额的过程。基金封闭期自基金成立日起最长不超过3个月(即最长3个月)，如果提前打开申购或赎回，公司会提前2日在公司网站或相关媒体上公告。",
                        showFlag: false
                    },
                    {
                        title: "2.申购和认购有什么区别？",
                        answer: "基金首次募集期购买基金的行为称为认购；在基金成立后购买基金的行为称为申购；一般情况下，认购期购买基金的费率相对来说要比申购期购买优惠。认购期购买的基金一般要经过封闭期才能赎回，申购的基金要在申购成功后的第二个工作日才能进行赎回。",
                        showFlag: false
                    },
                    {
                        title: "3.认购可以撤单吗？",
                        answer: "认购申请一经受理，不得撤销。投资者在募集期内可多次认购基金份额，其认购金额按照单笔认购金额对应的费率为基准进行计算。",
                        showFlag: false
                    },
                    {
                        title: "4.认购持有期是从什么时候开始算起的？认购冻结金额有利息吗？",
                        answer: "认购的基金持有期限从基金成立日开始算(例如：10月1日认购的新基金，假设基金于11月1日成立，则到12月1日，持有时间为31天)。认购期冻结资金会按原认购金额(不扣除认购费)计算利息，会折算成基金份额计入客户基金账户。",
                        showFlag: false
                    },
                    {
                        title: "5.我认购的基金为什么查不到份额？",
                        answer: "您认购的基金目前正处于验资期，验资结束后我司会公告基金成立，届时即可查询到份额确认情况。",
                        showFlag: false
                    },
                    {
                        title: "6.当投资者办理“认购”业务时，选择资金来源为 “大成钱柜”，办理的是什么业务？",
                        answer: "办理的是大成钱柜下的大成添利宝E(000726)向所认购基金的赎回转认购业务。",
                        showFlag: false
                    },
                    {
                        title: "7.什么是七日年化收益率和日每万份收益？",
                        answer: "日每万份收益是指每万份基金单位当日净收益。日每万份基金净收益＝当日基金净收益/当日基金份额总额×10000。七日年化收益率是指货币基金最近连续7个自然日每万份基金份额净收益折合成的年收益率，代表过去的收益情况，仅供参考。招财宝基金收益分配方式是每日分配、按日支付。收益是T+2个工作日起可以赎回。当您在今日赎回时，昨日的收益需要下个工作日才可以赎回。",
                        showFlag: false
                    },
                    {
                        title: "8.大成旗下的基金产品在法定节假日期间是否暂停申购？",
                        answer: "有些基金在法定节假日期间确实会暂停申购，具体情况请您提前关注我们的公司公告，提前做好交易安排，以免造成不便。",
                        showFlag: false
                    }
                ];
                this.warningHtml =
                    "1.钱柜买基金”实质为基金转换交易(适用于已开通转换业务的基金)或赎回转认/申购交易(适用于未开通转换业务的基金)等业务。通过“钱柜买基金”功能，可享手续费率优惠。最低10元起购。<br>2.大成基金网上直销平台可7*24小时进行交易。工作日15:00之后或节假日的交易申请将顺延至下一个工作日提交。如周日的交易，视为是下周一当日的交易，周一15：00以后的交易，视为是周二当日的交易。";
            } else if (this.activeName == "2") {
                this.commonQuestion = [
                    {
                        title: "基金赎回按什么净值成交？",
                        answer: "基金赎回采用“份额赎回、未知价法”，即投资者的赎回以份额方式申请，以申请当日的基金份额净值为基准计算。扣除相应的赎回费后，确认实际赎回金额。",
                        showFlag: false
                    },
                    {
                        title: "我在银行赎回基金，要多久到账？",
                        answer: "货币型基金、理财产品T+1个工作日划款，标普500基金、纳斯达克基金T+7个工作日划款，其他基金T+2个工作日划款。我们将直接划款到银行，然后由银行划款到您账户。到帐速度看银行内部的划款速度。",
                        showFlag: false
                    },
                    {
                        title: "多次申购的基金，赎回时是赎回哪部分份额？",
                        answer: "赎回按“先进先出”原则，也就是先购买的份额先赎回。",
                        showFlag: false
                    },
                    {
                        title: "赎回款一直没有到账，是什么原因？",
                        answer: "货币型基金、理财产品T+1个工作日划款，标普500基金、纳斯达克基金T+7个工作日划款，其他基金T+2个工作日划款。如超过上述期限三个工作日，赎回款仍未到账，请持有大成网上直销账号的客户先确认自己的赎回交易是否被确认，并核对您查询的银行卡是否是您购买基金时使用的银行卡。之后再拨打我们的客服电话(免长途话费)：400 888 5558进行进一步的咨询。",
                        showFlag: false
                    },
                    {
                        title: "我以前是在代销机构买的大成基金，能不能在网上交易办理赎回？",
                        answer: "不能直接办理。您需要先办理基金转托管手续，将代销机构的基金份额转托管至大成基金网上交易，方可在网上交易办理赎回。<br>操作流程如下：<br>第一步：开通大成基金网上交易<br>第二步：前往代销机构办理转托管转出手续；<br>第三步：转出之后2个工作日登录网上交易系统查询份额。<br>注：自建TA：代销机构在申报转托管时需填写销售商代码209，网点号根据网上交易使用的银行卡填写不同的代码，参照如下：209柜台客户，3000其他银联通客户，3100兴业银联通客户，3200浦发银联通客户，3300中信银联通客户，3400富滇银联通客户，3500长沙银联通客户，3600南京银联通客户，3700金华银联通客户，3800上农商银联通客户，4000工行网银客户，5000好易联客户，A000农行网银客户，B000建行网银客户，G000招行网银客户，J000民生网银客户，6000天天盈客户。如果代销渠道的系统不能填写网点号，则不能转托管到大成网上交易。<br>中登TA：销售商代码填680209，网点号填680209或不填，默认转到网上交易开户的银行卡上。",
                        showFlag: false
                    },
                    {
                        title: "赎回非货币基金时选择“赎回到大成钱柜”，大成基金份额什么时候可用？",
                        answer: "赎回非货币基金时选择资金赎回到“大成钱柜”，等同于把该基金转换或者赎回转申购为货币基金，货币基金份额需要在转换或者赎回转申购交易确认成功后才可使用。",
                        showFlag: false
                    }
                ];
                this.warningHtml =
                    "1、如果您是从中银易商渠道转来的客户，可下载大成基金APP完成相关操作，官网不支持该项服务。给您带来的不便深表歉意。如有疑问可拨打大成基金客服热线进行咨询：400-888-5558。<br>2、大成基金网上直销平台可7*24小时进行交易。工作日15:00之后或节假日的交易申请将顺延至下一个工作日提交。如周日的交易，视为是下周一当日的交易，周一15：00以后的交易，视为是周二当日的交易。<br> 3、您最终申请提交时间以我公司注册登记中心接收时间为准。";
            } else if (this.activeName == "3") {
                this.commonQuestion = [
                    {
                        title: "1.请问大成哪些基金开通了转换？",
                        answer: "您可以在我司官网进入您需要查询的基金的专栏，于产品公告中查看相关公告。",
                        showFlag: false
                    }
                ];
                this.warningHtml =
                    "1.基金交易崇尚长期投资，不提倡短线波段操作！<br>2.大成基金网上直销平台可7*24小时进行交易。工作日15:00之后或节假日的交易申请将顺延至下一个工作日提交。如周日的交易，视为是下周一当日的交易，周一15：00以后的交易，视为是周二当日的交易。";
            } else if (this.activeName == "4") {
                this.commonQuestion = [];
                this.warningHtml =
                    "1.该业务能实现不能转换或尚未开通转换业务的基金之间的间接转换，操作简单，方便安全！";
            }
        }
    }
};
</script>

<style lang="scss">
@import "../../assets/css/varibles";
.quick-box {
    background: #ffffff;
    border: 1px solid #f1f1f1;
    position: relative;
    margin-bottom: 20px;
    .tab {
        margin: 0 25px;
        .el-tabs__header {
            margin-bottom: 10px;
        }
        .el-tabs__nav-wrap:after {
            background: #f1f1f1;
        }
        .el-tabs__nav-scroll {
            line-height: 70px;
            .el-tabs__active-bar {
                bottom: 5px;
                height: 3px;
                background: $color-a;
            }
            .el-tabs__item {
                font-size: $f20;
                font-weight: 400;
            }
            .el-tabs__item.is-active {
                font-weight: 500;
            }
        }
        .el-tabs__content {
            padding: 0 0 20px;
            .fund-offset .cell {
                padding: 0 10px 0 20px;
            }
            .fund-arr {
                padding: 0 20px;
                .cell {
                    padding: 0;
                }
            }
        }
    }
}
</style>
